import { gql } from '@apollo/client';

export const PERMISSION_FRAGMENTS = gql`
  fragment PermissionFields on Permission {
    id
    name
    slug
    description
    permissionFor
    group {
      id
      name
      slug
    }
  }
`;
